export default __webpack_public_path__ + "static/media/Search.1c735e3b.svg";